export const MAX_DRAWER_WIDTH = 700;
export const MIN_DRAWER_WIDTH = 400;
export const MAP_OVERLAY_VIEW_OFFSET_LEFT = 100;
export const MAP_OVERLAY_VIEW_WIDTH = 1232;
export const MAP_OVERLAY_VIEW_HEIGHT = 692;

export const MAX_ORGAN_DOTS_PER_ROW = 20;
export const AIRCRAFT_SVG_SIZE = 25;

// ZOOM
export const GEO_MAP_SCROLL_DELTA = 100;
export const GEO_MAP_SCROLL_MULTIPLIER = 4;
export const GEO_MAP_MIN_SCALE = 1000;
export const GEO_MAP_MAX_SCALE = 10000;
